import _ from "lodash";
import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import SubMenuCurriculumWrapper from "Administrator/commonComponents/SubMenuCurriculumWrapper";
import { getNextMenuRoute } from "Administrator/modules/AdministratorModule";
import { getRelativePath } from "Utils";
import { goToRelativeRoute } from "modules/Services";
import { getIsAccountConfigurationEnabled } from "Utils/ACLStoreUtils";
export default store => ({
  path: "students",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-schoolSetup" */ "./components"),
        import(
          /* webpackChunkName: "admin-schoolSetup" */ "./modules/StudentsModule"
        ),
        import(
          /* webpackChunkName: "admin-schoolSetup" */ "./components/CreateStudent/containers/CreateStudentModule"
        ),
        import(
          /* webpackChunkName: "admin-schoolSetup" */ "./components/EditStudent/containers/StudentDetailsModule"
        ),
        import(
          /* webpackChunkName: "admin-schoolSetup" */ "./components/BulkActionsModal/modules/BulkActionsModalModule"
        ),
        import(
          /* webpackChunkName: "course-manage-family" */ "Course/routes/ManageFamily/modules/ManageFamilyModule"
        ),
        import(
          /* webpackChunkName: "admin-schoolSetup" */ "./components/BulkActions/modules/BulkActionsModule"
        ),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
          importedModule4,
          importedModule5,
          importedModule6,
        ]) => {
          const component = importedModule0.default;
          const module2 = importedModule1;
          const createStudentModule = importedModule2;
          const studentDetailsModule = importedModule3;
          const studentBulkActionsModule = importedModule4;
          const bulkActionsModule = importedModule6;

          const reducer = module2.default;
          const key = module2.NAME;
          injectReducer(store, {
            key,
            reducer,
          });
          injectReducer(store, {
            key: createStudentModule.NAME,
            reducer: createStudentModule.default,
          });
          injectReducer(store, {
            key: studentDetailsModule.NAME,
            reducer: studentDetailsModule.default,
          });
          injectReducer(store, {
            key: studentBulkActionsModule.NAME,
            reducer: studentBulkActionsModule.default,
          });
          injectReducer(store, {
            key: "manageFamily",
            reducer: importedModule5.default,
          });
          injectReducer(store, {
            key: bulkActionsModule.NAME,
            reducer: bulkActionsModule.default,
          });

          return component;
        }
      )
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter(nextState, replace) {
    if (
      _.last(nextState.routes).path == "students" &&
      !getIsAccountConfigurationEnabled()
    ) {
      const route = getNextMenuRoute("STUDENTS");
      if (route) {
        const goToNewRoute = goToRelativeRoute({
          route: getRelativePath(route),
        });
        store?.dispatch(goToNewRoute);
      }
    }
  },
  childRoutes: [SubMenuCurriculumWrapper(store)],
});
